<template>
  <v-container fluid>
    <v-row v-if="student">
      <v-col cols="12" md="6">
        <v-form ref="updateStudentForm" @submit="updateStudent">
          <v-card>
            <v-toolbar dense flat color="blur">Base info</v-toolbar>
            <v-divider/>
            <v-card-text class="pb-0">
              <v-text-field label="First name"
                            v-model="student.first_name"
                            color="secondary"
                            validate-on-blur outlined dense
                            :rules="[v => !!v || 'First name is required']"
                            :error-messages="api_errors['first_name']"
              />

              <v-text-field label="Last name"
                            v-model="student.last_name"
                            color="secondary"
                            validate-on-blur outlined dense
                            :rules="[v => !!v || 'Last name is required']"
                            :error-messages="api_errors['last_name']"
              />
            </v-card-text>
            <v-divider/>
            <v-list>
              <v-list-item>
                <v-list-item-icon><v-icon color="success">mdi-account</v-icon></v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-subtitle>Nickname</v-list-item-subtitle>
                  <v-list-item-title>{{ student.nickname }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider inset/>

              <v-list-item>
                <v-list-item-icon><v-icon color="success">mdi-email</v-icon></v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-subtitle>Sign-in email</v-list-item-subtitle>
                  <v-list-item-title>{{ student.email }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider inset/>

              <v-list-item>
                <v-list-item-icon><v-icon color="success">mdi-map-marker</v-icon></v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-subtitle>Address</v-list-item-subtitle>
                  <v-list-item-title>{{ student.country }} {{ student.address }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider inset/>

              <v-list-item>
                <v-list-item-icon><v-icon color="success">mdi-video</v-icon></v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-subtitle>Zoom Personal Meeting ID</v-list-item-subtitle>
                  <v-list-item-title>{{ student.zoom_id }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider inset/>

              <v-list-item>
                <v-list-item-icon><v-icon color="success">mdi-linkedin</v-icon></v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-subtitle>LinkedIn</v-list-item-subtitle>
                  <v-list-item-title>{{ student.linked_in }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider inset/>

              <v-list-item>
                <v-list-item-icon><v-icon color="success">mdi-skype</v-icon></v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-subtitle>Skype</v-list-item-subtitle>
                  <v-list-item-title>{{ student.skype }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
            <v-divider/>
            <v-card-actions>
              <v-spacer/>
              <v-btn small color="primary" type="submit">Update</v-btn>
            </v-card-actions>
          </v-card>
        </v-form>

      </v-col>
      <v-col cols="12" md="6">
        <v-card class="mb-3">
          <v-toolbar flat dense color="blur">Session limits</v-toolbar>
          <v-divider/>
          <v-card-text>
            <v-chip color="primary" class="ma-1 box-shadow" v-for="(item, idx) in student.session_limits" :key="idx">
              {{ item.name}} - {{ item.count}}
            </v-chip>
          </v-card-text>
        </v-card>

        <v-card class="mb-3">
          <v-toolbar flat dense color="blur">Summary</v-toolbar>
          <v-divider/>
          <v-card-text class="ql-editor" v-html="student.summary"></v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  props: {
    student: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    api_errors: []
  }),
  mounted() {
    console.log(this.$route.params.student_id)
  },
  methods: {
    updateStudent(e) {
      e.preventDefault()
      if(!this.$refs.updateStudentForm.validate()) return;
      this.axios.put(`api/students/${this.$route.params.student_id}/`, this.student)
          .then(() => {this.$emit('loadStudent')})
      // this.table_data.items = await this.axios.put(`api/students`).then(({data}) => data.data)
    },
  }

}
</script>